import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Event, KeyStatResult, Opportunity } from '@wdx/clmi/clmi-swagger-gen';
import { CrudStatus } from '@wdx/shared/utils';
import { Observable, map } from 'rxjs';
import * as eventActions from './event.actions';
import { State } from './event.reducer';
import * as eventSelectors from './event.selectors';

@Injectable({
    providedIn: 'root',
})
export class EventFacadeService {
    store$ = inject(Store<State>);

    getEventById$(eventId: string): Observable<Event | null> {
        return this.store$
            .select(eventSelectors.getEventData())
            .pipe(
                map((eventData) =>
                    eventId === eventData.id ? eventData.event : null,
                ),
            );
    }

    getOpportunitiesById$(eventId: string): Observable<Opportunity[] | null> {
        return this.store$
            .select(eventSelectors.getOpportunitiesData())
            .pipe(
                map((eventData) =>
                    eventId === eventData.id ? eventData.opportunities : null,
                ),
            );
    }

    getKeyStats$(eventId: string): Observable<KeyStatResult[] | null> {
        return this.store$
            .select(eventSelectors.getKeyStatsData())
            .pipe(
                map((keyStatsData) =>
                    eventId === keyStatsData.id ? keyStatsData.keyStats : null,
                ),
            );
    }

    getEventStatus$(): Observable<CrudStatus> {
        return this.store$.select(eventSelectors.getEventStatus());
    }

    getOpportunitiesStatus$(): Observable<CrudStatus> {
        return this.store$.select(eventSelectors.getOpportunityStatus());
    }

    getKeyStatsStatus$(): Observable<CrudStatus> {
        return this.store$.select(eventSelectors.getKeyStatsStatus());
    }

    loadEventById(eventId: string): void {
        this.store$.dispatch(eventActions.getEventById({ eventId }));
    }

    loadOpportunitiesById(eventId: string): void {
        this.store$.dispatch(eventActions.getOpportunitiesById({ eventId }));
    }

    loadKeyStats(eventId: string): void {
        this.store$.dispatch(eventActions.getKeyStats({ eventId }));
    }
}
